import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
  addComparisonPlan,
  removeComparisonPlan,
  setQuotationParams,
  openModalQuotationDateWarning,
  openModalQuotationDateYear,
  openModalWithoutTracker,
  closeModalFilterCategory,
  setInfosModalProspect,
  trackerModalValidatorHandlerBlur,
  validateTrackerModalRedirect,
  applyFilterCategories,
  clearFilterCategories,
  searchEcommerceSettings,
  searchProviderSettings,
} from '../../../actions/searchActions';

import SearchBarDesktop from './components/searchBarDesktop';

import PlansTable from '../../v2/search/components/plansTable';
import SearchBarMobile from './components/searchBarMobile';
import SpecialistBlock from '../../../components/search/plans_table/SpecialistBlock';

import ComparisonBar from '../../../components/search/comparison_bar/ComparisonBar.module';
import ModalQuotationDateWarning from '../../../components/common/modal_quotation_date_warning/ModalQuotationDateWarning';
import ModalQuotationDateYear from '../../../components/common/modal_quotation_date_year/ModalQuotationDateYear';
import ModalWithoutTracker from '../../../components/common/modal_without_tracker/ModalWithoutTracker';
import { isSameDaySearch, quotationDateYear, verifyOriginSearchUrl, formatDateToMonthYear, getDaysInAdvance } from '../../../utils';

import { Filters } from './components/filter';
import { FloatingFilter } from './components/filter/components/FloatingFilter';
import { Helmet } from 'react-helmet';
import Upsell from '../../../components/V2/upsell';


import matomoTracker from '../../../utils/matomo';
import styles from './styles.module.css';

function Search(props) {
  const mobile = props.mobile;

  useEffect(() => {
    const { destination, begin_date, end_date } = props.match.params || {};

    if (destination && begin_date && end_date) {
      const formattedDate = formatDateToMonthYear(begin_date);
      const daysInAdvance = getDaysInAdvance(begin_date);
      matomoTracker.trackSearch(destination, formattedDate, daysInAdvance);
    }


    if (begin_date && isSameDaySearch(begin_date) && !(props.userDetails && props.userDetails.operator_permissions)) {
      props.openModalQuotationDateWarning();
    }

    if (begin_date && end_date && quotationDateYear(begin_date, end_date)) {
      props.openModalQuotationDateYear();
    }

    if (props.location && verifyOriginSearchUrl(props.location.search)) {
      props.openModalWithoutTracker();
    }
  }, [
    props.match && props.match.params && props.match.params.begin_date,
    props.match && props.match.params && props.match.params.end_date,
    props.match && props.match.params && props.match.params.destination,
    props.location && props.location.search,
    props.userDetails && props.userDetails.operator_permissions,
  ]);

  return (
    <main>
      <Helmet>
        <body className={styles.body} />
      </Helmet>
      <section>
        {mobile && <SearchBarMobile />}
        {!mobile && <SearchBarDesktop />}
      </section>
      <div className={styles.grid}>
        {!mobile && (
          <aside className={styles.aside}>
            <SpecialistBlock />
            <Filters />
          </aside>
        )}
        <section className={styles.plansTable}>
          <PlansTable />
          {mobile && <FloatingFilter />}
        </section>
        {props.comparisonPlans.length > 0 && <ComparisonBar />}

        {props.isModalQuotationDateWarningActive && <ModalQuotationDateWarning />}
        {props.isModalQuotationDateYearActive && <ModalQuotationDateYear />}
        {props.isModalWithoutTrackerActive && (
          <ModalWithoutTracker
            isModalWithoutTrackerActive={props.isModalWithoutTrackerActive}
            prospect={props.modalProspect}
            modalProspectAvaliable={props.modalProspectAvaliable}
            setInfosModalProspect={props.setInfosModalProspect}
            trackerModalValidatorHandlerBlur={props.trackerModalValidatorHandlerBlur}
            coupon={props.coupon}
            redirectToTracker={(cupom) => {
              props.validateTrackerModalRedirect(
                props.match.params.destination,
                props.match.params.begin_date,
                props.match.params.end_date,
                cupom
              );
            }}
          />
        )}
        {props.isModalUpsellActive && <Upsell /> }
      </div>
    </main>
  );
}

const mapStateToProps = (state) => ({
  comparisonPlans: state.search.comparisonPlans,
  userDetails: state.search.userDetails,
  coupon: state.purchase.coupon,
  mobile: state.mobile.mobileActive,
  isModalWithoutTrackerActive: state.search.isModalWithoutTrackerActive,
  isModalQuotationDateWarningActive: state.search.isModalQuotationDateWarningActive,
  isModalQuotationDateYearActive: state.search.isModalQuotationDateYearActive,
  isModalFilterCategoryActive: state.search.isModalFilterCategoryActive,
  isModalUpsellActive: state.search.isModalUpsellActive,
  modalProspect: state.search.modalProspect,
  modalProspectAvaliable: state.search.modalProspectAvaliable,
  filterCategory: state.search.filterCategory,
  filterProvider: state.search.filterProvider,
  ecommerce_settings: state.search.ecommerce_settings,
  providers: state.global.providers,
  destinations: state.global.destinations,
});

export default connect(mapStateToProps, {
  searchEcommerceSettings,
  searchProviderSettings,
  addComparisonPlan,
  removeComparisonPlan,
  setQuotationParams,
  openModalQuotationDateWarning,
  openModalQuotationDateYear,
  openModalWithoutTracker,
  closeModalFilterCategory,
  setInfosModalProspect,
  trackerModalValidatorHandlerBlur,
  validateTrackerModalRedirect,
  applyFilterCategories,
  clearFilterCategories,
})(Search);



// WEBPACK FOOTER //
// ./src/views/v2/search/index.jsx